import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { useCallback } from "react";
import useLocalization from "localization/useLocalization";

export default function LanguageToggle() {

  const { setPublicPageLanguage, locale } = useLocalization()
  const onLanguageSelected = useCallback(
    (_, lang) => setPublicPageLanguage(lang), [setPublicPageLanguage])

  return <ToggleButtonGroup value={locale}
                            exclusive
                            onChange={onLanguageSelected}>
    <ToggleButton value="fr" sx={style.button} data-testid="language-toggle-french-button">
      FR
    </ToggleButton>
    <ToggleButton value="" disabled sx={style.separator} data-testid="language-toggle-english-button">
      |
    </ToggleButton>
    <ToggleButton value="en" sx={style.button}>
      ENG
    </ToggleButton>
  </ToggleButtonGroup>
}

const style = {
  button: {
    border: "none",
    width: "4rem",
    "&": {
      color: 'text.primary',
    },
    "&:first-of-type": {
      paddingLeft: 0
    },
    "&:last-of-type": {
      paddingRight: 0
    },
    "&.Mui-selected": {
      textDecoration: "underline",
      fontWeight: "bold",
      backgroundColor: "transparent"
    }
  },
  separator: {
    paddingLeft: 0,
    paddingRight: 0,
    border: "none",
    color: 'text.primary',
    "&.Mui-disabled": {
      border: "none",
      color: 'text.primary',
    }
  }
}